export interface IncrementConfig {
    element: HTMLElement;
    speed?: number;
}

export class Increment {
    private readonly element: HTMLElement;
    protected speed: number;

    constructor({element, speed = 60}: IncrementConfig) {
        this.element = element;
        this.speed = speed;
        this.init();
    }

    public getLastNumber(): number {
        const last = +this.element.getAttribute(`data-number`);
        if (!isNaN(last)) return last;
        throw new Error('Can`t increment an element, the content is not a number');
    }

    public increment(last: number): void {
        let counter = 0;

        let interval = setInterval(() => {
            counter = counter + Math.ceil( last / 50 );
            this.element.innerText = `${counter}`;
            if (counter > last) {
                this.element.innerText = `${last}`;
                clearInterval(interval);
            }
        }, this.speed);
    }

    protected init(): void {
        if (!this.element) return;
        window.addEventListener('scroll', () => {
            let position = this.element.getBoundingClientRect().top;
            let win = window.innerHeight - 40;
            if (position < win && this.element.textContent === `0`) {
                this.increment(this.getLastNumber());
            }
        });
    }
}